module.exports = __webpack_public_path__ + "5e88d31ac6e613ef815a030a76f05beb.ttf";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/fonts/Avenir-Light.ttf
// module id = 641
// module chunks = 0